export default {
  add_items: 'Aggiungi articoli',
  remove_items: 'Rimuovi articoli',
  place_order: 'Ordina',
  pay_now: 'Paga ora · {{amount}}',
  go_to_menu: 'Vai al menu',
  secure_checkout: 'Pagamento sicuro...',

  error_messages: {
    payment_unsuccessful: {
      title: 'Pagamento fallito',
      description: 'Verifica i dati di pagamento e riprova.',
    },
    internal_error: {
      title: 'Ordine non riuscito 😔',
      description:
        'Purtroppo si è verificato un problema inatteso con il tuo ordine, il nostro team tecnico è già al lavoro 🛠️.',
    },
    order_blocked: {
      title: 'Ordine bloccato',
      description:
        "Abbiamo rilevato attività sospetta dal tuo account e bloccato i nuovi ordini fino al {{datetime}}. Contatta il supporto all'indirizzo {{supportEmail}} per i dettagli.",
      description_no_datetime:
        "Abbiamo rilevato attività sospetta dal tuo account e bloccato i nuovi ordini. Contatta il supporto all'indirizzo {{supportEmail}} per i dettagli.",
    },
  },

  toasts: {
    input_errors_found: 'Ci sono alcuni problemi con le informazioni del tuo ordine',
    select_payment_method: "Scegli un metodo di pagamento per effettuare l'ordine.",
  },
};
